// eslint-disable-next-line no-restricted-imports
import Button, { ButtonProps as ButtonPropsBase } from '@mui/material/Button';

import { CSSObject, styled } from '../styled';

import {
  getStandardMode,
  getOutlinedMode,
  getSmallMode,
  getTextMode,
  getMediumMode,
  getOutlinedSmallMode,
  getStandardSmallMode,
} from './mode';
import { ButtonClasses, ButtonProps } from './types';

export const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'colorVariant' && prop !== 'loading',
})<Omit<ButtonPropsBase, 'color'> & ButtonProps>(
  ({ theme, mode, loading, colorVariant = 'primary' }) => ({
    boxShadow: 'none',
    textTransform: 'inherit',
    '&:focus': {
      boxShadow: 'none',
    },
    [ButtonClasses.label.css]: {
      lineHeight: '100%',
    },

    ...(mode === 'standard' && getStandardMode(theme, colorVariant)),
    ...(mode === 'standard-small' && getStandardSmallMode(theme, colorVariant)),
    ...(mode === 'outlined' && getOutlinedMode(theme, colorVariant)),
    ...(mode === 'medium' && getMediumMode(theme, colorVariant)),
    ...(mode === 'small' && getSmallMode(theme)),
    ...(mode === 'text' && getTextMode(theme, colorVariant)),
    ...(mode === 'outlined-small' && getOutlinedSmallMode(theme, colorVariant)),

    ...(loading && {
      [ButtonClasses.loading.css]: {
        opacity: 0,
      },
    }),

    [ButtonClasses.loading.css]: {
      position: 'absolute',
      display: 'flex',
    },

    [`${ButtonClasses.icon.css} svg`]: {
      transition: 'none',
    } as CSSObject,
  })
);
